let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1BI0w")).then(() => parcelRequire('kNLEl'));